/**
 * Created by asiulik on 21.12.2017.
 */

define(['jquery', './contentLoadmore'], function ($, ContentLoadMore) {

    function Content() {
    }

    Content.prototype.init = function () {

        var contentLoadMore = new ContentLoadMore();
        contentLoadMore.init();

        this.initMask();

        return {
            contentLoadMore: contentLoadMore
        }

    };

    Content.prototype.initMask = function () {

        var $dataMaskElements = $('[data-mask-field]');

        if (!$dataMaskElements.length) return;

        [].forEach.call($dataMaskElements, function (maskElement) {

          var $maskElement = $(maskElement);
            $maskElement.mask($maskElement.data('mask-field'));

        });

    };

    return Content;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/content/content.js